<template>
  <ModalPrimary v-bind="modalAttrs"
                :name="modalName"
                @before-open="beforeModalOpen">
    <div :style="containerStyle">
      <HeaderLargePrimary :style="headerStyle">
        Add Required Skills
      </HeaderLargePrimary>
      <div :style="innerContainerStyle">
        Add required skills for {{ tenantTeamName }}.
        <validation-observer ref="observer"
                             :style="validationObserverStyle">
          <validation-provider name="tags"
                               rules="required|min:1">
            <TagInputSkill placeholder="Enter skill name"
                           v-model="tags"
                           :excludes="excludes"
                           :style="inputStyle" />
          </validation-provider>
        </validation-observer>
      </div>
      <div :style="buttonsContainerStyle">
        <ButtonSecondary :style="cancelButtonStyle"
                         @click="cancel">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary :disabled="buttonDisabled"
                       :style="doneButtonStyle"
                       @click="addRequiredSkills">
          Done
        </ButtonPrimary>
      </div>
    </div>
  </ModalPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/button/button-primary'
  import ButtonSecondary from '@modules/button/button-secondary'
  import ClickOutside from 'vue-click-outside'
  import HeaderLargePrimary from '@modules/text/header-large-primary'
  import ModalPrimary from '@modules/modal/modal-primary'
  import TagInputSkill from '@modules/input/tag-input-skill'
  import { FontStyle, Layout } from '@js/styles'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { min, required } from '@js/validators/rules'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalAddRequiredSkills',
    directives: {
      ClickOutside,
    },
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      ModalPrimary,
      TagInputSkill,
      ValidationObserver,
      ValidationProvider,
    },
    data: function () {
      return {
        buttonsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },
        cancelButtonStyle: {
          minWidth: '80px',
        },
        containerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          height: '267px',
          justifyContent: 'space-between',
          width: '100%',
        },
        doneButtonStyle: {
          minWidth: '68px',
        },
        headerStyle: {
          lineHeight: FontStyle.size.lg,
        },
        initRequiredSkills: [],
        innerContainerStyle: {
          width: '100%',
        },
        input: '',
        inputStyle: {
          left: 0,
          position: 'absolute',
          top: 0,
        },
        limit: 30,
        limitTagsText: '',
        modalAttrs: {
          maxWidth: 480,
          minHeight: 320,
        },
        modalName: MODAL_WINDOW_NAMES.ADD_REQUIRED_SKILLS_PRIMARY,
        tags: [],
        tagSeparator: ' ,;',
        tenantTeamId: null,
        tenantTeamName: '',
        validationObserverStyle: {
          display: 'block',
          height: '35px',
          margin: `${Layout.space.lg} 0 0 0`,
          position: 'relative',
          width: '100%',
        },
        validSkill: '',
      };
    },
    created: function () {
      this.limitTagsText = `Required skills can be added up to ${this.limit} at one time.`;
    },
    computed: {
      buttonDisabled: function () {
        return this.tags.filter(elem => elem.trim().length > 0).length === 0;
      },
      excludes: function () {
        return this.initRequiredSkills.map(elem => elem.label);
      },
    },
    methods: {
      addRequiredSkills: function () {
        this.$emit('add-required-skills', this.tags);
        this.close();
      },
      beforeModalOpen: function (e) {
        this.initRequiredSkills = e.params ? (e.params.requiredSkills ? e.params.requiredSkills : []) : [];
        this.tenantTeamId = e.params ? (e.params.tenantTeamId ? e.params.tenantTeamId : null) : null;
        this.tenantTeamName = e.params ? (e.params.tenantTeamName ? e.params.tenantTeamName : '') : '';
      },
      cancel: function () {
        this.clear();
        this.close();
      },
      clear: function () {
        this.initRequiredSkills = [];
        this.tags = [];
        this.tenantTeamId = null;
        this.tenantTeamName = '';
      },
      close: function () {
        this.$modal.hide(this.modalName);
      },
    },
  };
</script>
